/* eslint-disable jsx-a11y/anchor-is-valid */
import URL from "constant/url";
import { useNavigate } from "react-router-dom";

export default function DedicatedServerCategory() {
  const navigate = useNavigate();
  return (
    <li className="menu-item hostie-has-dropdown mega-menu">
      <a href="#" className="hostie-dropdown-main-element">
        Dedicated Server
      </a>
      <div className="rts-mega-menu">
        <div className="wrapper">
          <div className="row g-0">
            <div className="col-lg-12">
              <ul className="mega-menu-item">
                <p style={{ color: "#083A5E" }}>THEO KHU VỰC</p>
                <li>
                  <a
                    href=""
                    onClick={() => {
                      navigate(URL.ListDedicatedServerEU);
                    }}
                  >
                    <img
                      src="assets/flags/european-union.png"
                      alt="server"
                      width={45}
                      height={45}
                    ></img>
                    <div className="info">
                      <p>Dediacated Châu Âu</p>
                    </div>
                  </a>
                </li>
                <li style={{ marginTop: "-16px" }}>
                  <a
                    href=""
                    onClick={() => {
                      navigate(URL.ListDedicatedServerUS);
                    }}
                  >
                    <img
                      src="assets/flags/united-states.png"
                      alt="server"
                      width={45}
                      height={45}
                    ></img>
                    <div className="info">
                      <p>Dediacated Mỹ</p>
                    </div>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </li>
  );
}
